export default "__VITE_ASSET__Bj0bTtEB__"